export interface TransformedConversationStats {
  outboundCountByCampaignStatus: Record<string, number>;
  conversationCountBySource: Record<string, number>;
  callDurationStats: {
    total: number;
    callCount: number;
    average: number;
  };
  lastUpdatedAt: number;
  isLoading: boolean;
}

export type ConversationStats = {
  outboundByStatus: Record<string, number>;
  bySource: Record<string, number>;
  callDuration: {
    total: number;
    callCount: number;
    average: number;
  };
};

function transformConversationStats(
  conversationStats: ConversationStats
): TransformedConversationStats {
  return {
    outboundCountByCampaignStatus: conversationStats.outboundByStatus,
    conversationCountBySource: conversationStats.bySource,
    callDurationStats: conversationStats.callDuration,
    lastUpdatedAt: Date.now(),
    isLoading: false,
  };
}

export { transformConversationStats };
